import { Title } from "@mantine/core";
import { modals } from "@mantine/modals";
import React, { useEffect } from "react";
import ModalUpdateExcelProduct from "../../ProductManager/ProductList/ModalUpdate/ModalUpdateExcelProduct";
import { useLocation } from "react-router-dom";

const UpdateExcelSEOSp = () => {
  const location = useLocation();
  modals.openConfirmModal({
    title: (
      <>
        <div color="white">
          <Title order={5}>Upload Excel SEO sản phẩm</Title>
        </div>
      </>
    ),
    children: <ModalUpdateExcelProduct location={location} />,
    confirmProps: { display: "none" },
    cancelProps: { display: "none" },
    closeOnClickOutside: false,
    closeOnEscape: false,
    withCloseButton: false,
  });
  return <div></div>;
};

export default UpdateExcelSEOSp;
